module.exports = __webpack_public_path__ + "static/img/yunsheng03.088699e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunsheng03.jpg
// module id = S/a2
// module chunks = 0